import React from 'react';

import {
    DesktopContainer,
    MobileClickableContainer,
    MobileClickableText,
    StepItem,
    StepBadge,
    StepBadgeInner,
    StepNumber,
    StepText,
    ListTitle,
    StepDivider
} from './styledComponents';

interface CustomListProps {
    title?: string;
    steps?: any;
}

interface StepItemComponentProps {
    step: any;
    stepIndex: number;
}

const StepItemComponent: React.FC<StepItemComponentProps> = ({
    step,
    stepIndex,
}) => {
    const isActive = step.isActive || false;

    return (
        <StepItem className="custom-list-step-item">
            <StepBadge $isActive={isActive} className="custom-list-step-badge">
                {isActive ? (
                    <StepBadgeInner className="custom-list-step-badge-inner">
                        <StepNumber $isActive={isActive} className="custom-list-step-number">
                            {stepIndex + 1}
                        </StepNumber>
                    </StepBadgeInner>
                ) : (
                    <StepNumber $isActive={isActive} className="custom-list-step-number">
                        {stepIndex + 1}
                    </StepNumber>
                )}
            </StepBadge>
            <StepText $isActive={isActive} className="custom-list-step-text">
                {step.stepContent}
            </StepText>
        </StepItem>
    );
};

const CustomList: React.FC<CustomListProps> = (props) => {
    const {
        title,
        steps
    } = props

    const stepData = JSON.parse(steps)

    return (
        <>
            <DesktopContainer className="custom-list-desktop">
                <ListTitle className="custom-list-list-title">{title}</ListTitle>
                {stepData.map((step, index) => (
                    <React.Fragment key={index}>
                        <StepItemComponent step={step} stepIndex={index} />
                        {index < stepData.length - 1 && <StepDivider />}
                    </React.Fragment>
                ))}
            </DesktopContainer>

            <MobileClickableContainer
                className="custom-list-mobile-trigger"
                role="button"
            >
                <MobileClickableText>{title}</MobileClickableText>
            </MobileClickableContainer>
        </>
    );
};

export default CustomList;
